import {Stack} from "@mui/material";
import Box from "@mui/material/Box";
import RelevantLinkBlock from "./fragments/RelevantLinkBlock";
import SectionHeading from "./SectionHeading";

const partners = [
    {
        name: "Беларусбанк",
        image: "images/bank/belarusbank.jpg",
        sections: [
            {
                title: "Кредит «Лёгка ехаць» на приобретение автомобилей, электромобилей в БелАвтоЭксперт",
                bullets: [
                    "Без первоначального взноса;",
                    "Сниженная процентная ставка в 6/12 месяцев 9,75%-14%;",
                    "Срок кредита до 10 лет;",
                    "Возможность оформления кредита без предоставления справки о доходах;",
                    "Возможность оформить кредит и заключить кредитный договор онлайн;",
                    "Удобные способы погашения кредита (в отделениях и инфокиосках банка, с использованием систем Интернет-банкинг, М-банкинг, Автооплата).",
                ],
                link: {
                    href: "https://belarusbank.by/ru/fizicheskim_licam/kredit/consumer/40946",
                    label: "подробнее о кредите «Лёгка ехаць» на официальном сайте Беларусбанка",
                },
            },
            {
                title: "Кредит на приобретение автомобиля или электромобиля нового или с пробегом",
                bullets: [
                    "Без первоначального взноса;",
                    "Ставка: 18%-18,5%;",
                    "Срок кредита: до 7-10 лет;",
                    "Пониженная процентная ставка первые 180 календарных дней;",
                    "Отсрочка по уплате основного долга в течение 6 месяцев;",
                    "Возможность самостоятельно заполнить онлайн-заявку на кредит;",
                    "Возможность оформления кредита без предоставления справки о доходах;",
                    "Возможность предварительного рассмотрения вопроса о выдаче кредита без предоставления заявителем договора купли-продажи автомобиля, электромобиля;",
                    "Удобные способы погашения кредита (в отделениях и инфокиосках банка, через системы Интернет-банкинг, М-банкинг, Автооплата).",
                ],
                link: {
                    href: "https://belarusbank.by/ru/fizicheskim_licam/kredit/consumer/avtokredit",
                    label: "подробнее об автокредите на официальном сайте Беларусбанка",
                },
            },
        ],
    },
    {
        name: "АСБ Беларусбанк",
        image: "images/bank/asbBelarusbank.jpg",
        sections: [
            {
                title: "Лизинг транспортных средств для частных лиц",
                bullets: [
                    "Транспортное средство новое: срок лизинга до 120 месяцев, авансовый платеж от 20%, валюта: BYN;",
                    "Транспортное средство с пробегом: срок лизинга до 114 месяцев, авансовый платеж от 30%, валюта: BYN;",
                    "GEELY: срок лизинга до 120 месяцев, авансовый платеж от 20%, валюта: BYN.",
                ],
                link: {
                    href: "https://asbleasing.by/leasing_for_individuals/lizing-ts/",
                    label: "подробнее о лизинге транспортных средств для частных лиц на официальном сайте ОАО 'АСБ Беларусбанк'",
                },
            },
            {
                title: "Лизинг для Вас и вашего бизнеса",
                bullets: [
                    "На общих условиях: срок до 60 месяцев;",
                    "Авансовый платеж от 10%;",
                    "Валюта: BYN.",
                ],
                link: {
                    href: "https://asbleasing.by/leasing-for-business/",
                    label: "подробнее о лизинге для Вас и вашего бизнеса на официальном сайте ОАО 'АСБ Беларусбанк'",
                },
            },
        ],
    },
    {
        name: "Агролизинг",
        image: "images/bank/agroleasing.jpg",
        sections: [
            {
                title: "Лизинг автомобилей Geely физическим лицам",
                bullets: [
                    "Специальные условия на новые автомобили Geely для физических лиц;",
                    "Срок лизинга до 10 лет;",
                    "Аванс от 10%;",
                    "Ставка по лизингу: 15 % (СР НБРБ + 5,25 п.п.);",
                    "Валюта: BYN.",
                ],
                link: {
                    href: "https://agroleasing.by/cars_cat/geely/",
                    label: "подробнее о лизинге на новые автомобили Geely на официальном сайте лизинговой компании ОАО \"Агролизинг\"",
                },
            },
            {
                title: "Лизинг автомобилей любых марок и моделей, новых и с пробегом",
                bullets: [
                    "Ставка по лизингу: 15 % (СР НБРБ + 5,25 п.п.);",
                    "Срок лизинга: до 10 лет на новые авто, до 7 лет для б/у авто;",
                    "Аванс от 10%;",
                    "Валюта: BYN.",
                ],
                link: {
                    href: "https://agroleasing.by/fizicheskim-licam/lizing-transportnyh-sredstv/",
                    label: "подробнее о лизинге на все автомобили любых марок и моделей, новых и с пробегом на официальном сайте лизинговой компании ОАО \"Агролизинг\"",
                },
            },
            {
                title: "Лизинг электромобилей для физических лиц, включая электромобили Geely",
                bullets: [
                    "Ставка по лизингу: первые 6 платежей - 13,75 % (СР НБРБ + 4 п.п.), далее - 14,75% (СР НБРБ + 5 п.п.);",
                    "Срок лизинга до 10 лет;",
                    "Размер задатка по договору лизинга от 20%;",
                    "Валюта: BYN.",
                ],
                link: {
                    href: "https://agroleasing.by/fizicheskim-licam/lizing-elektromobilej/",
                    label: "подробнее о лизинге на электромобили на официальном сайте лизинговой компании ОАО \"Агролизинг\"",
                },
            },
            {
                title: "Лизинг транспортных средств для юридических лиц",
                bullets: [
                    "Ставка по лизингу: 15% в BYN (СР НБРБ + 5,25 п.п.);",
                    "Ставка по лизингу: 22% в RUB, 10% в USD (при условии наличия источников финансирования);",
                    "Выкупная стоимость: 1-25%;",
                    "Срок лизинга: от 1 до 5 лет;",
                    "Аванс от 20%.",
                ],
                link: {
                    href: "https://agroleasing.by/yuridicheskim-licam/lizing-transportnyx-sredstv/",
                    label: "подробнее о лизинге транспортных средств для юридических лиц на официальном сайте лизинговой компании ОАО \"Агролизинг\"",
                },
            },
            {
                title: "Лизинг электромобилей для юридических лиц",
                bullets: [
                    "Ставка по лизингу: 15%;",
                    "Срок лизинга: от 1 до 5 лет;",
                    "Аванс от 20%;",
                    "Валюта: BYN.",
                ],
                link: {
                    href: "https://agroleasing.by/yuridicheskim-licam/lizing-elektromobilej-2/",
                    label: "подробнее о лизинге электромобилей для юридических лиц на официальном сайте лизинговой компании ОАО \"Агролизинг\"",
                },
            },
            {
                title: "Специальные условия на новые автомобили Geely для юридических лиц",
                bullets: [
                    "Ставка по лизингу: 15,25 % (СР НБРБ + 5,5 п.п.);",
                    "Срок лизинга до 60 месяцев;",
                    "Аванс от 20%;",
                    "Валюта: BYN.",
                ],
                link: {
                    href: "https://agroleasing.by/cars_cat/geely/#urlic2",
                    label: "подробнее о специальных условиях на новые автомобили Geely для юридических лиц на официальном сайте лизинговой компании ОАО \"Агролизинг\"",
                },
            },
        ],
    },
    {
        name: "Proleasing",
        image: "images/bank/proleasing.jpg",
        sections: [
            {
                title: "Лизинг для физических лиц на новые автомобили, автомобили с пробегом и электромобили",
                bullets: [
                    "В белорусских рублях, гибкий график платежей, сроком до 5 лет;",
                    "Пакеты услуг:",
                    "Экспресс: любой автомобиль, без справок, быстрое решение. Аванс от 25%. Стоимость до 200 000 BYN. Срок лизинга до 60 месяцев. Одобрение сделки до 2 часов;",
                    "Индивидуальный: специальные условия, персональные опции, индивидуальный график платежей. Аванс от 10%. Стоимость без ограничений. Срок лизинга до 60 месяцев. Одобрение сделки до 1 дня;",
                    "Стандарт: любой автомобиль, минимальный пакет документов, быстрое решение. Аванс от 10%. Стоимость без ограничений. Срок лизинга до 60 месяцев. Одобрение сделки до 8 часов;",
                    "Возвратный: удобное привлечение средств, честная оценка вашего имущества, быстрое решение. Аванс от 25%. Стоимость без ограничений. Срок лизинга до 60 месяцев. Одобрение сделки до 1 дня;",
                    "Электромобили: льготы на уплату таможенных пошлин, отсутствие НДС. Аванс от 10%. Стоимость без ограничений. Срок лизинга до 60 месяцев. Одобрение сделки до 1 дня.",
                ],
                linkNode: (
                    <span style={{fontSize: "0.8em"}}>
                        подробнее о лизинге <a href="https://pro.by/fizicheskie-lica/lizing-novyh-avtomobilej">на новые автомобили</a>, <a href="https://pro.by/fizicheskie-lica/lizing-avtomobilej-s-probegom">на автомобили с пробегом</a>, <a href="https://pro.by/fizicheskie-lica/lizing-elektromobilej">на электромобили</a> на официальном сайте лизинговой компании <a href="https://pro.by">Proleasing</a>.
                    </span>
                ),
            },
            {
                title: "Лизинг для ИП и юридических лиц на новые автомобили, автомобили с пробегом и электромобили",
                bullets: [
                    "Валюта на выбор, гибкий график платежей, сроком до 8 лет;",
                    "Пакеты услуг:",
                    "Стартап: минимальный пакет документов, быстрое решение для нового бизнеса, возможно без поручительства. Аванс от 25%. Стоимость без ограничений. Срок лизинга до 60 месяцев. Одобрение сделки от 1 дня;",
                    "Моментальный Pro: быстрое решение для нового бизнеса, минимальный пакет документов, мгновенное решение. Аванс от 35%. Стоимость до 40 000 USD. Срок лизинга до 60 месяцев. Одобрение сделки: уже одобрено;",
                    "Экспресс Pro: любой автомобиль, без финансовых документов, быстрое решение. Аванс от 25%. Стоимость до 69 000 USD. Срок лизинга до 96 месяцев. Одобрение сделки до 2 часов;",
                    "Стандарт Pro: любой автомобиль, быстрое решение, больше аванс - меньше документов. Аванс от 10%. Стоимость без ограничений. Срок лизинга до 96 месяцев. Одобрение сделки от 1 дня;",
                    "Индивидуальный Pro: персональный (сезонный) график платежей, специальные условия, эксклюзивные опции. Аванс от 10%. Стоимость без ограничений. Срок лизинга до 96 месяцев. Одобрение сделки от 1 дня;",
                    "Такси. Прокат. Автошкола: для нового бизнеса, расширение парка, КАСКО по желанию клиента. Аванс от 20%. Стоимость без ограничений. Срок лизинга до 60 месяцев. Одобрение сделки в течение дня.",
                ],
                linkNode: (
                    <span style={{fontSize: "0.8em"}}>
                        подробнее о лизинге <a href="https://pro.by/yuridicheskie-lica/lizing-avtomobilej">на автомобили</a>, <a href="https://pro.by/yuridicheskie-lica/lizing-elektromobili">на электромобили</a> на официальном сайте лизинговой компании <a href="https://pro.by">Proleasing</a>.
                    </span>
                ),
            },
        ],
    },
    {
        name: "Алфин лизинг",
        image: "images/bank/alfinleasing.jpg",
        showName: true,
        sections: [
            {
                title: "Лизинг для частных лиц",
                bullets: [
                    "Легковые автомобили в лизинг;",
                    "Без справки о доходах;",
                    "Выбор автомобиля в любом городе Беларуси;",
                    "Одобрение за 15 минут после получения необходимых сведений и документов;",
                    "Указываем в предложении все платежи без скрытых комиссий;",
                    "КАСКО не требуется.",
                ],
                link: {
                    href: "https://allfin.by/",
                    label: "подробнее о лизинге для частных лиц на официальном сайте лизинговой компании Алфин",
                },
            },
            {
                title: "Лизинг для юридических лиц и ИП",
                bullets: [
                    "Легковые и коммерческие автомобили в лизинг;",
                    "Срок лизинга до 7 лет;",
                    "Аванс от 20%;",
                    "Одобрение по УНП;",
                    "Собственное финансирование без банков и дополнительных услуг;",
                    "Один раз отправляем список документов, которые нужны для оформления лизинга, и больше не запрашиваем новые;",
                    "Указываем все платежи по лизингу без скрытых комиссий;",
                    "Выбор за Вами, нужна страховка КАСКО или нет.",
                ],
                link: {
                    href: "https://allfin.by/biznesu/",
                    label: "подробнее о лизинге для юридических лиц и ИП на официальном сайте лизинговой компании Алфин",
                },
            },
        ],
    },
    {
        name: "EuroTime Leasing",
        image: "images/bank/eurotimeleasing.jpg",
        sections: [
            {
                title: "Лизинг автомобилей и специальной техники",
                bullets: [
                    "Стоимость авто: 10 000 - 1 500 000 USD;",
                    "Автомобили не старше 10 лет на момент заключения договора;",
                    "Аванс: 10% - 40%;",
                    "Срок лизинга: от 13 до 84 месяцев;",
                    "Валюта договора: для физических лиц - BYN, для юридических лиц - EUR, BYN, USD, RUB;",
                    "Платежи: равные или убывающие, возможен индивидуальный график;",
                    "Все платежи осуществляются в белорусских рублях по курсу НБ РБ без дополнительных сборов и комиссий.",
                ],
                link: {
                    href: "https://etime.by/#about",
                    label: "подробнее о лизинге на официальном сайте EuroTime Leasing",
                },
            },
        ],
    },
    {
        name: "Lux Leasing",
        image: "images/bank/luxleasing.png",
        frameStyle: {
            padding: "0",
        },
        imageStyle: {
            width: "100%",
            height: "100%",
            maxWidth: "none",
            maxHeight: "none",
            objectFit: "cover",
            objectPosition: "center",
        },
        sections: [
            {
                title: "Лизинг легкового автотранспорта для физических лиц",
                bullets: [
                    "Авансовый платеж: на новые автомобили - 10% - 40%, на б/у автомобили - 20% - 40%;",
                    "Срок лизинга 1 - 7 лет;",
                    "Валюта: BYN;",
                    "Предмет лизинга: новый или б/у автомобиль не старше 18 лет;",
                    "Гибкость платежей (возможность учесть сезонность);",
                    "Финансовый и возвратный лизинг;",
                    "Минимальный документооборот;",
                    "Быстрое принятие решения;",
                    "Оплата по ЕРИП;",
                    "Обязательное страхование. Выбор страховой компании на усмотрение лизингополучателя.",
                ],
                link: {
                    href: "https://luxleasing.by/lizing-dlya-fizicheskih-lic/lizing-legkovogo-avtotransporta/",
                    label: "подробнее о лизинге для физических лиц на официальном сайте Lux Leasing",
                },
            },
            {
                title: "Лизинг легкового автотранспорта для юридических лиц и ИП",
                bullets: [
                    "Авансовый платеж: на новые автомобили - 10% - 40%, на б/у автомобили - 20% - 40%;",
                    "Срок лизинга 1 - 5 лет;",
                    "Валюта: BYN, USD, EUR. Оплата осуществляется в белорусских рублях, в случае валютного графика - в белорусских рублях по курсу НБ РБ на дату проведения платежа;",
                    "Предмет лизинга: новый или б/у автомобиль не старше 18 лет;",
                    "Гибкость платежей (возможность учесть сезонность);",
                    "Финансовый, возвратный и импортный лизинг;",
                    "Минимальный документооборот;",
                    "Быстрое принятие решения;",
                    "Обязательное страхование. Выбор страховой компании на усмотрение лизингополучателя.",
                ],
                link: {
                    href: "https://luxleasing.by/lizing-dlya-yuridicheskih-lic/lizing-legkovogo-avtotransporta/",
                    label: "подробнее о лизинге для юридических лиц и ИП на официальном сайте Lux Leasing",
                },
            },
        ],
    },
    {
        name: "Ringo Leasing",
        image: "images/bank/ringoleasing.jpg",
        sections: [
            {
                title: "Лизинг новых и б/у автомобилей",
                bullets: [
                    "Валюта: BYN;",
                    "Любые модели от 1995 года выпуска;",
                    "Срок лизинга до 60 месяцев;",
                    "Низкий первоначальный взнос;",
                    "Гибкий график финансирования;",
                    "Досрочный выкуп автомобиля через 12 месяцев.",
                ],
                link: {
                    href: "https://ringoleasing.by/",
                    label: "подробнее о лизинге на официальном сайте Ringo Leasing",
                },
            },
        ],
    },
    {
        name: "МТБанк",
        image: "images/bank/mtbank.jpg",
        sections: [
            {
                title: "Кредит «Большие планы»",
                bullets: [
                    "Процентная ставка 18,9% переменная (СКО (11,25%) * 1,68);",
                    "Срок погашения: до 84 месяцев;",
                    "Кредит: до 70 000 BYN для оплаты б/у автомобилей; до 100 000 BYN для оплаты новых автомобилей, а также б/у автомобилей с пробегом не более 5000 км и возрастом не старше 1 года;",
                    "Сумма кредита от 500 до 100 000 BYN, но не более стоимости приобретаемого автотранспортного средства, указанной в документе на оплату;",
                    "Безналичное перечисление денежных средств на счет партнера;",
                    "Без справки о доходах, залога и поручителей;",
                    "Досрочное погашение: без штрафов и комиссий;",
                    "Без скрытых комиссий - только ставка.",
                ],
                link: {
                    href: "https://www.mtbank.by/credits/bolshie-plany",
                    label: "подробнее о кредите на официальном сайте МТ Банка",
                },
            },
            {
                title: "Автолизинг для физических лиц",
                bullets: [
                    "Фиксированная процентная ставка в белорусских рублях;",
                    "Любой автомобиль: новый или автомобиль с пробегом не старше 25 лет на момент окончания срока лизинга;",
                    "Без справки о доходах;",
                    "Без залога и поручительства;",
                    "Быстрое рассмотрение: принятие решения о сделке в течение 1-го часа.",
                ],
                link: {
                    href: "https://www.mtbank.by/leasing/private-person",
                    label: "подробнее о лизинге на официальном сайте МТ Банка",
                },
            },
        ],
    },
    {
        name: "Сбер Банк",
        image: "images/bank/sberbank.jpeg",
        sections: [
            {
                title: "Кредит «Купи авто в online»",
                bullets: [
                    "Процентная ставка: 18,49% (СР НБРБ + 8,74 п.п.);",
                    "Без первоначального взноса;",
                    "Максимальная сумма до 65 000 руб.;",
                    "Срок: до 10 лет;",
                    "Без справок о доходах;",
                    "Без поручителей;",
                    "Кредитуем новые и б/у автомобили от партнеров банка;",
                    "Без залога авто, без КАСКО;",
                    "Возможно досрочное погашение без штрафных санкций в любой момент;",
                    "Последнее место работы клиента должно быть не менее 3 месяцев на территории РБ;",
                    "Оформление заявки на кредит онлайн;",
                    "Деньги перечисляются вам на счет на основании договора купли-продажи.",
                ],
                link: {
                    href: "https://www.sber-bank.by/credit-potreb/buy-car/percents",
                    label: "подробнее о кредите «Купи авто в online» на официальном сайте Сбер Банка",
                },
            },
            {
                title: "Кредит «Автокредит у партнёров»",
                bullets: [
                    "Без первоначального взноса;",
                    "Процентная ставка от 5,5%;",
                    "Максимальная сумма до 80 000 руб.;",
                    "Срок: до 10 лет;",
                    "Без справок о доходах;",
                    "Возможность узнать максимальную сумму кредита до заключения договора купли-продажи на приобретение автомобиля;",
                    "Кредит до 100% стоимости автомобиля;",
                    "Деньги перечисляются на счет продавца;",
                    "Кредитуем новые и б/у автомобили от партнеров банка;",
                    "Без залога, без КАСКО;",
                    "Возможность оформления заявки на кредит онлайн;",
                    "Быстрое решение.",
                ],
                link: {
                    href: "https://www.sber-bank.by/credit-potreb/buy-car/conditions",
                    label: "подробнее о кредите «Автокредит у партнёров» на официальном сайте Сбер Банка",
                },
            },
            {
                title: "Автокредит «Заведи и поехали»",
                bullets: [
                    "Процентная ставка от 3,9%;",
                    "Максимальная сумма до 300 000 руб.;",
                    "Срок кредита до 10 лет;",
                    "Без справок о доходах;",
                    "Возможность полного или частичного досрочного погашения без штрафных санкций;",
                    "Срок рассмотрения заявки 30 минут;",
                    "Деньги перечисляются сразу на счет продавца;",
                    "Доля собственных средств - не менее 10% стоимости автомобиля;",
                    "Способ обеспечения - залог приобретаемого за счет кредита автотранспортного средства.",
                ],
                link: {
                    href: "https://www.sber-bank.by/credit-auto/zavedi-i-poehali/conditions",
                    label: "подробнее об автокредите на официальном сайте Сбер Банка",
                },
            },
        ],
    },
    {
        name: "Белагропромбанк",
        image: "images/bank/agroprombank.jpg",
        sections: [
            {
                title: "Кредит на автомобиль, электромобиль",
                bullets: [
                    "Процентная ставка от 17,9%;",
                    "Максимальная сумма до 90% стоимости автомобиля;",
                    "Валюта кредита: белорусские рубли;",
                    "Срок кредитования до 10 лет.",
                ],
                link: {
                    href: "https://www.belapb.by/chastnomu-klientu/kredity/kredit-na-avtomobil",
                    label: "подробнее о кредите на официальном сайте Белагропромбанка",
                },
            },
        ],
    },
    {
        name: "Банк Дабрабыт",
        image: "images/bank/dabrabyt.jpg",
        sections: [
            {
                title: "Лизинг автомобиля",
                bullets: [
                    "До 100% стоимости автомобиля;",
                    "Срок лизинга: от 1 до 10 лет;",
                    "Новое авто или авто с пробегом;",
                    "В белорусских рублях;",
                    "Без справки о доходах;",
                    "Собственные средства от 0 до 39% стоимости автомобиля;",
                    "Выкупная стоимость - 1% стоимости лизингового автомобиля;",
                    "Оформление заявки на лизинг авто в отделениях Банка Добробыт.",
                ],
            },
        ],
    },
    {
        name: "СберЛизинг",
        image: "images/bank/sberleasing.jpg",
        sections: [
            {
                title: "Лизинг легковых автомобилей",
                bullets: [
                    "Сумма лизинга без ограничений;",
                    "Срок лизинга до 10 лет;",
                    "Первоначальный взнос от 0%;",
                    "Обработка документов от 1 часа до 2 дней;",
                    "Новые авто: аванс от 10%, срок лизинга до 10 лет, договор в BYN без привязки к курсу валют;",
                    "Авто с пробегом: аванс от 20% до 40%, срок лизинга до 84 месяцев, договор в BYN без привязки к курсу валют;",
                    "Возвратный лизинг: аванс от 20%, срок лизинга до 84 месяцев, досрочный выкуп через 12 месяцев.",
                ],
                link: {
                    href: "https://sberleasing.by/",
                    label: "подробнее о лизинге на официальном сайте СберЛизинга",
                },
            },
            {
                title: "Автомобили из Китая",
                bullets: [
                    "Предмет лизинга: транспортное средство до 3.5 тонн;",
                    "Клиенты: граждане Республики Беларусь либо лица без гражданства, постоянно проживающие на территории Республики Беларусь, возраста не меньше 21 года и не старше 63 лет на дату выкупа предмета лизинга;",
                    "Срок лизинга: до 7 лет на б/у автомобили и 10 лет на новые;",
                    "Авансовый платеж: от 30%;",
                    "Валюта финансирования: белорусские и российские рубли без привязки к курсу валюты;",
                    "Оплата лизинговых платежей: в белорусских рублях;",
                    "Автомобили: новые и с пробегом не старше 20 лет на конец срока лизинга;",
                    "График лизинговых платежей: равномерный (аннуитет), убывающий;",
                    "Возвратный лизинг: рефинансируем сделки других лизинговых компаний либо профинансируем вас под ваше авто.",
                ],
                link: {
                    href: "https://sberleasing.by/news/avtomobili-iz-kitaya/",
                    label: "подробнее о лизинге на официальном сайте СберЛизинга",
                },
            },
        ],
    },
    {
        name: "Промагролизинг",
        image: "images/bank/promagroleasing.jpg",
        sections: [
            {
                title: "Лизинговая программа «Лидер дорог»",
                bullets: [
                    "Предмет лизинга: автотранспортные средства;",
                    "Авансовый платеж от 10% от стоимости авто с учетом НДС;",
                    "Срок лизинга от 120 месяцев;",
                    "Быстрое рассмотрение документов;",
                    "Валюта договора: белорусский рубль;",
                    "Ставка по лизингу: ставка рефинансирования НБ РБ, увеличенная не менее чем на 5,5 п.п.;",
                    "Обеспечение: задаток и/или не менее одного платежеспособного поручителя; возможно заключение договора без обеспечения;",
                    "Выкупная стоимость 1% стоимости авто с учетом НДС;",
                    "Возможен досрочный выкуп;",
                    "Страхование АВТОКАСКО;",
                    "Ежемесячная периодичность уплаты лизинговых платежей.",
                ],
                link: {
                    href: "https://pal.by/programmy-lizinga/lizingovaa-programma-lider#auto",
                    label: "подробнее о лизинге «Лидер дорог» на официальном сайте Промагролизинга",
                },
            },
            {
                title: "Лизинговая программа «Заряжай и езжай»",
                bullets: [
                    "Предмет лизинга: новые электромобили;",
                    "Валюта договора: безналичные белорусские рубли;",
                    "Срок лизинга: до 120 месяцев;",
                    "Ставка по лизингу: первые 12 мес. - 13,75% (фиксированная ставка), далее с 13 месяца - ставка рефинансирования НБ РБ, увеличенная на 5,0 п.п.;",
                    "Авансовый платеж от 10% от стоимости авто без НДС;",
                    "Обеспечение: задаток и/или не менее одного платежеспособного поручителя; возможно заключение договора без обеспечения;",
                    "Выкупная стоимость: 1% стоимости авто с учетом НДС;",
                    "Возможен досрочный выкуп в соответствии с условиями договора лизинга и действующего законодательства РБ;",
                    "Страхование по системе АВТОКАСКО осуществляется лизингодателем по действующим тарифам;",
                    "Ежемесячная периодичность уплаты лизинговых платежей.",
                ],
                link: {
                    href: "https://pal.by/programmy-lizinga/lizingovaa-programma-zarazaj#auto",
                    label: "подробнее о лизинге «Заряжай и езжай» на официальном сайте Промагролизинга",
                },
            },
        ],
    },
    {
        name: "А-Лизинг",
        image: "images/bank/a-leasing.jpg",
        sections: [
            {
                title: "Автолизинг",
                bullets: [
                    "Новые авто и авто с пробегом;",
                    "Авансовый платеж от 10%;",
                    "Срок лизинга от 12 до 120 месяцев.",
                ],
                link: {
                    href: "https://a-leasing.by/",
                    label: "подробнее о лизинге на официальном сайте А-Лизинга",
                },
            },
        ],
    },
    {
        name: "Активлизинг",
        image: "images/bank/activeleasing.jpg",
        sections: [
            {
                title: "Лизинг новых и с пробегом легковых автомобилей",
                bullets: [
                    "Сумма лизинга: до 250 000 BYN;",
                    "Срок лизинга до 7 лет;",
                    "Рассмотрение сделки от 1 часа;",
                    "Первоначальный взнос: от 0%;",
                    "Новые авто: аванс от 10% до 40%, срок лизинга 12 - 84 месяцев, валюта - BYN, RUB, USD, EUR;",
                    "Авто с пробегом: аванс от 20%, возраст авто до 10 лет, стоимость - от 10 000 USD;",
                    "TRADE-IN: аванс от 20%, ваш старый авто идет в зачет стоимости приобретаемого автомобиля.",
                ],
                link: {
                    href: "https://www.alizing.by/cars-leasing",
                    label: "подробнее о лизинге на официальном сайте Активлизинга",
                },
            },
        ],
    },
    {
        name: "General Leasing",
        image: "images/bank/general-leasing.jpg",
        sections: [
            {
                title: "Лизинг новых и б/у автомобилей для физических лиц и ИП",
                bullets: [
                    "Любая сумма финансирования;",
                    "Авто любого года выпуска и модели;",
                    "Без поручителей, залогов и справок о доходе;",
                    "Лизинг без первого взноса;",
                    "Гибкий график финансирования;",
                    "Досрочный выкуп автомобиля через 12 месяцев;",
                    "На новой машине уезжаете в день оформления.",
                ],
                link: {
                    href: "https://generalleasing.by/",
                    label: "подробнее о лизинге на официальном сайте General Leasing",
                },
            },
        ],
    },
    {
        name: "Микролизинг",
        image: "images/bank/microleasing.jpg",
        sections: [
            {
                title: "Лизинг новых и б/у автомобилей для ИП и юридических лиц",
                bullets: [
                    "Валюта договора: BYN, USD, EUR, RUB;",
                    "Срок рассмотрения заявки 1 день;",
                    "Аванс: от 10% до 39% стоимости авто;",
                    "Минимум документов;",
                    "Срок лизинга: от 1 года до 7 лет;",
                    "Лизинговые платежи: равные, убывающие, индивидуальный график;",
                    "Без КАСКО: авто стоимостью до 20 000 EUR (по курсу НБРБ на день оплаты), старше 5 лет;",
                    "Автомобиль для такси без КАСКО при авансе от 30%, срок лизинга 3 года.",
                ],
                link: {
                    href: "https://mikro-leasing.by/yuridicheskim-licam/lizing-legkovyh-avtomobilej",
                    label: "подробнее о лизинге для ИП и юридических лиц на официальном сайте Микролизинга",
                },
            },
            {
                title: "Лизинг для физических лиц: авто, техника и транспорт",
                bullets: [
                    "Стоимость транспорта от 2 000 USD (по курсу НБРБ на день оплаты);",
                    "Срок лизинга: от 13 до 84 месяцев;",
                    "Аванс от 10% до 39% стоимости транспортного средства;",
                    "Валюта договора: BYN.",
                ],
                link: {
                    href: "https://mikro-leasing.by/dlja-fizicheskih-lic",
                    label: "подробнее о лизинге для физических лиц на официальном сайте Микролизинга",
                },
            },
        ],
    },
];

function PartnerSection({section}) {
    return (
        <div className="mt-4 ms-4">
            <h5>{section.title}</h5>
            <ul>
                {section.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                ))}
            </ul>
            {section.linkNode || (
                section.link && (
                    <a style={{fontSize: "0.8em"}} href={section.link.href}>
                        {section.link.label}
                    </a>
                )
            )}
        </div>
    );
}

function PartnerCard({partner}) {
    return (
        <div className="my-5">
            <div
                className="mb-3"
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    flexWrap: "wrap",
                    minHeight: "72px",
                }}
            >
                <div
                    style={{
                        width: "220px",
                        height: "72px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        backgroundColor: "#fff",
                        border: "1px solid #e5e5e5",
                        borderRadius: "8px",
                        padding: "10px 16px",
                        ...partner.frameStyle,
                    }}
                >
                    <img
                        src={partner.image}
                        alt={partner.name}
                        style={{
                            maxWidth: "100%",
                            maxHeight: "44px",
                            width: "auto",
                            height: "auto",
                            objectFit: "contain",
                            ...partner.imageStyle,
                        }}
                    />
                </div>
                {partner.showName && <span style={{fontWeight: "bold"}}>{partner.name}</span>}
            </div>
            <Stack spacing={2}>
                {partner.sections.map((section) => (
                    <PartnerSection key={section.title} section={section}/>
                ))}
            </Stack>
        </div>
    );
}

export default function Loan() {
    const relevantUrls = ["/blog/1"];

    return (
        <div className="site-section">
            <div className="container">
                <SectionHeading
                    sectionHeadingTitle={"Сотрудничество по кредитам и лизингам"}
                    sectionHeadingMessage={
                        <>
                            <p>В автосалоне БелАвтоЭксперт любой автомобиль в наличии и под заказ можно приобрести, оформив лизинг или кредит.</p>
                            <p>
                                Мы придаем особое значение выбору наших партнеров, включая лизинговые компании, поэтому можем подобрать оптимальный и удобный способ приобретения автомобиля под ваш бюджет и задачу.
                            </p>
                            <Stack direction="row" spacing={2}>
                                <Box>
                                    <a href="tel:+375291888969" className="btn btn-red">
                                        <span className="icon-phone"></span> Получить консультацию
                                    </a>
                                </Box>
                                <Box>
                                    <a href="/listing" className="btn btn-white">
                                        <span className="icon-car"></span> Каталог авто
                                    </a>
                                </Box>
                            </Stack>
                        </>
                    }
                />
                <div className="row">
                    <div className="col-lg-7 ml-auto order-lg-1">
                        <h4 className="my-4">Наши партнеры</h4>
                        <Stack spacing={1}>
                            {partners.map((partner) => (
                                <PartnerCard key={partner.name} partner={partner}/>
                            ))}
                        </Stack>
                    </div>
                    <div className="col-lg-4 order-lg-2">
                        <RelevantLinkBlock relevantUrls={relevantUrls}/>
                    </div>
                </div>
            </div>
        </div>
    );
}
